import React from 'react';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import ListTeamFilterString from './ListTeamFilterString';
import ListTeamFilterCategory from './ListTeamFilterCategory';
var tableStyles = require('src/imports/styles/extend.table.scss');
var ListTeamFilter = function (props) { return (React.createElement(Row, { gutter: 24, className: tableStyles.filterRow },
    React.createElement(Col, { xs: 24, md: 14 },
        React.createElement(ListTeamFilterString, { setFilters: props.setFilters })),
    React.createElement(Col, { xs: 24, md: 10 },
        React.createElement(ListTeamFilterCategory, { categories: props.categories, setFilters: props.setFilters })))); };
export default ListTeamFilter;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListTeamPage/ListTeamFilter.tsx
// module id = 1091
// module chunks = 0